import React from 'react';
import { ThemeProvider } from './ThemeProvider';
import { NotificationProvider } from './NotificationProvider';
import { PermissionsProvider } from './PermissionsProvider';

const AppProvider = ({ children }) => {
  return (
    <ThemeProvider>
      <NotificationProvider>
        <PermissionsProvider>
          {children}
        </PermissionsProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
};

export default AppProvider;
